import React from "react";
import { getAnimatedLayerStyle, ANIMATIONS } from "./../../../helper/lpcHelper.js";

/**
 * PixelCharacterFigure — personagem RPG pixel art (Universal LPC Spritesheet).
 * Sobrepoe N camadas PNG ordenadas por lpcZ (body=10 embaixo, shield=90 em cima)
 * e anima trocando o frame do spritesheet.
 *
 * Props:
 *  - equipped: [{ name, slot, lpcLayer, lpcZ }]
 *  - scale: 1-6 (default 5 = 320x320)
 *  - direction: 0=N, 64=W, 128=S (default), 192=E
 *  - animation: 'idle' | 'walk' | 'slash' | 'hurt' | ... (default 'idle')
 *  - playOnce: animacao de acao (slash/hurt) que toca e volta pro idle
 *  - onAnimationEnd: callback quando a animacao playOnce termina
 *  - background / hideScenery: aparencia do palco
 */
class PixelCharacterFigure extends React.Component {

  constructor(props) {
    super(props);
    this.state = { frame: 0, current: props.animation || 'idle' };
  }

  componentDidMount() {
    this.startLoop();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.animation !== this.props.animation) {
      this.setState({ frame: 0, current: this.props.animation || 'idle' }, () => this.startLoop());
    }
  }

  componentWillUnmount() {
    this.stopLoop();
  }

  stopLoop() {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  }

  startLoop() {
    this.stopLoop();
    var spec = ANIMATIONS[this.state.current] || ANIMATIONS.idle;
    var self = this;

    this.timer = setInterval(function () {
      self.setState(function (st) {
        var s = ANIMATIONS[st.current] || ANIMATIONS.idle;
        var next = st.frame + 1;

        if (next >= s.frames) {
          if (s.loop) return { frame: 0 };
          // animacao de acao terminou: volta pro repouso
          self.stopLoop();
          if (self.props.onAnimationEnd) self.props.onAnimationEnd(st.current);
          setTimeout(function () {
            if (self.timer === null) {
              self.setState({ frame: 0, current: 'idle' }, () => self.startLoop());
            }
          }, 0);
          return { frame: s.frames - 1 };
        }
        return { frame: next };
      });
    }, 1000 / spec.fps);
  }

  render() {
    var equipped = this.props.equipped || [];
    var scale = this.props.scale || 5;
    var direction = (typeof this.props.direction === 'number') ? this.props.direction : 128;

    // Filtra so itens que tem lpcLayer (compatibilidade com items DiceBear)
    var lpcItems = equipped.filter(function (e) { return !!e.lpcLayer; });

    // Ordena por lpcZ (do menor pro maior — desenha de baixo pra cima)
    lpcItems.sort(function (a, b) { return (a.lpcZ || 50) - (b.lpcZ || 50); });

    // Garantir que tem pelo menos um body — se nao, mostra base default
    var hasBody = lpcItems.some(function (i) { return i.slot === 'body'; });
    if (!hasBody) {
      lpcItems.unshift({
        name: 'Default',
        slot: 'body',
        lpcLayer: 'body/bodies/male/walk.png',
        lpcZ: 10
      });
    }

    var size = 64 * scale;
    var frame = this.state.frame;
    var anim = this.state.current;

    return (
      <div style={{
        position: 'relative',
        width: size + 'px',
        height: size + 'px',
        background: this.props.background || 'linear-gradient(180deg, #b3d9ff 0%, #87ceeb 50%, #98fb98 100%)',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: this.props.hideScenery ? 'none' : '0 8px 24px rgba(0,0,0,0.2)',
        border: this.props.hideScenery ? 'none' : '4px solid #FFD700',
        margin: '0 auto'
      }}>
        {/* Pixel grid background (decoracao) */}
        {!this.props.hideScenery && (
          <div style={{
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
            backgroundSize: (8 * scale) + 'px ' + (8 * scale) + 'px',
            pointerEvents: 'none'
          }} />
        )}

        {/* Camadas LPC empilhadas */}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: (64 * scale) + 'px',
          height: (64 * scale) + 'px',
          transform: 'translate(-50%, -50%)',
          overflow: 'hidden'
        }}>
          {lpcItems.map(function (item, idx) {
            return (
              <div
                key={item.lpcLayer + '_' + idx}
                style={Object.assign({}, getAnimatedLayerStyle(item.lpcLayer, scale, direction, anim, frame, item.animMap), {
                  zIndex: item.lpcZ || (10 + idx)
                })}
                title={item.name}
              />
            );
          })}
        </div>

        {/* Sombra no chao */}
        <div style={{
          position: 'absolute',
          bottom: '12%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: (24 * scale) + 'px',
          height: (4 * scale) + 'px',
          background: 'radial-gradient(ellipse, rgba(0,0,0,0.4) 0%, transparent 70%)',
          zIndex: 5,
          pointerEvents: 'none'
        }} />
      </div>
    );
  }
}

export default PixelCharacterFigure;
